const getRandomTies = () => {
    return Math.floor(Math.random() * 5)
}

export default getRandomTies